import { apiClient, unwrap } from './client';
import type { LoginResponse } from '@/types';

interface LoginInput { email: string; password: string; }
interface TwoFaInput { challengeToken: string; code: string; }
interface RefreshInput { refreshToken: string; }
interface RefreshResponse { accessToken: string; refreshToken: string; expiresIn: number; }

export const authApi = {
  login: async (input: LoginInput): Promise<LoginResponse> => {
    const res = await apiClient.post('/auth/login', input);
    return unwrap<LoginResponse>(res);
  },

  loginWith2fa: async (input: TwoFaInput): Promise<LoginResponse> => {
    const res = await apiClient.post('/auth/login/2fa', input);
    return unwrap<LoginResponse>(res);
  },

  refresh: async (input: RefreshInput): Promise<RefreshResponse> => {
    const res = await apiClient.post('/auth/refresh', input);
    return unwrap<RefreshResponse>(res);
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout').catch(() => {/* tolère l'échec serveur */});
  },

  /** Change son propre mot de passe. Le mot de passe actuel est exigé. */
  changerMotDePasse: async (input: ChangerMotDePasseInput): Promise<{ change: boolean }> => {
    const res = await apiClient.post('/auth/mot-de-passe', input, { _silentError: true } as any);
    return unwrap<{ change: boolean }>(res);
  },

  /**
   * Demande un lien de réinitialisation. La réponse est la même que l'email
   * existe ou non — l'écran ne doit pas révéler qui a un compte ici.
   */
  motDePasseOublie: async (email: string): Promise<MotDePasseOublieResponse> => {
    const res = await apiClient.post('/auth/mot-de-passe/oubli', { email }, { _silentError: true } as any);
    return unwrap<MotDePasseOublieResponse>(res);
  },
};

export interface ChangerMotDePasseInput {
  motDePasseActuel:  string;
  nouveauMotDePasse: string;
}

export interface MotDePasseOublieResponse {
  envoye:  boolean;
  message: string;
}
